module.exports = __webpack_public_path__ + "img/minus.dd086051.svg";